import { useQuery } from '@tanstack/react-query';
import { getCoaches } from 'api/coach';

const useGetCoachesListQuery = () => {
  return useQuery(['getCoaches'], () => getCoaches());
};

export default useGetCoachesListQuery;
